module.exports = "https://coursera_assets.s3.amazonaws.com/images/6e67df7456dda059aa1bc1588073231a.png";